'use strict';
(function () {
  angular.module('pentaApp').factory('clubPayWithPoints.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clubPayWithPoints');
  }
})();
